import { NavigationData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import StringToNumberPropTransformer from "../StringToNumberPropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const NAVIGATION_DATA_TAG = 'NavData';
export default class NavigationParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.NAVIGATION, FIXED_PROTOCOL_CONTENT_TYPE_IDS.NAVIGATION, NAVIGATION_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            hdg_gyro: new StringToNumberPropTransformer('hdg_gyro'),
            gyroA: 'gyroA',
            speed_error_correction: 'speed_error_correction',
            hdg_magn: new StringToNumberPropTransformer('hdg_magn'),
            mag_dev: new StringToNumberPropTransformer('mag_dev'),
            mag_var: new StringToNumberPropTransformer('mag_var'),
            rot: new StringToNumberPropTransformer('rot'),
            stw_ctw: 'stw_ctw',
            dist_og: new StringToNumberPropTransformer('dist_og'),
            dist_tw: new StringToNumberPropTransformer('dist_tw'),
            roll: new StringToNumberPropTransformer('roll'),
            pitch: new StringToNumberPropTransformer('pitch'),
            roll_period: new StringToNumberPropTransformer('roll_period'),
        };
    }
    createData(props) {
        return new NavigationData(props.hdg_gyro, props.gyroA, props.speed_error_correction, props.hdg_magn, props.mag_dev, props.mag_var, props.rot, props.stw_ctw, props.dist_og, props.dist_tw, props.roll, props.pitch, props.roll_period);
    }
}
//# sourceMappingURL=NavigationParser.js.map